import { render, staticRenderFns } from "./BulkSelectionBarActions.vue?vue&type=template&id=3a5360c8"
import script from "./BulkSelectionBarActions.vue?vue&type=script&lang=js"
export * from "./BulkSelectionBarActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports